module.exports = __webpack_public_path__ + "img/reason11.58673948.png";